/* tslint:disable */
/* eslint-disable */
export enum OfferDiscountType {
  Percentage = 'percentage',
  Amount = 'amount',
  Free = 'free'
}
